const perfilesTuberiaEstructural = 
[
  {
    id: 1,
    name: "tubo cuadrado 20x20x1.4",
    available : 10, // q tan disponible es este perfil del 1 al 10
    b: 0.020, // m
    h: 0.020, // m
    e: 0.0014, // m
    A: 0.99, // cm²
    pl: 0.78, // kg/m
    Ix: 0.56, // cm⁴
    Wx: 0.56, // cm³
    ix: 0.75, // cm
    Iy: 0.56, // cm⁴
    Wy: 0.56, // cm³
    iy: 0.75, // cm
  },
  {
    id: 2,
    name: "tubo cuadrado 20x20x1.5",
    b: 0.020, // m
    h: 0.020, // m
    e: 0.0015, // m
    A: 1.05, // cm²
    pl: 0.83, // kg/m
    Ix: 0.58, // cm⁴
    Wx: 0.58, // cm³
    ix: 0.75, // cm
    Iy: 0.58, // cm⁴
    Wy: 0.58, // cm³
    iy: 0.75, // cm
  },
  {
    id: 3,
    name: "tubo cuadrado 20x20x1.8",
    b: 0.020, // m
    h: 0.020, // m
    e: 0.0018, // m
    A: 1.23, // cm²
    pl: 0.96, // kg/m
    Ix: 0.66, // cm⁴
    Wx: 0.66, // cm³
    ix: 0.73, // cm
    Iy: 0.66, // cm⁴
    Wy: 0.66, // cm³
    iy: 0.73, // cm
  },
  {
    id: 4,
    name: "tubo cuadrado 20x20x2",
    b: 0.020, // m
    h: 0.020, // m
    e: 0.0020, // m
    A: 1.34, // cm²
    pl: 1.05, // kg/m
    Ix: 0.70, // cm⁴
    Wx: 0.70, // cm³
    ix: 0.72, // cm
    Iy: 0.70, // cm⁴
    Wy: 0.70, // cm³
    iy: 0.72, // cm
  },
  {
    id: 5,
    name: "tubo cuadrado 25x25x1.4",
    b: 0.025, // m
    h: 0.025, // m
    e: 0.0014, // m
    A: 1.27, // cm²
    pl: 1.00, // kg/m
    Ix: 1.16, // cm⁴
    Wx: 0.93, // cm³
    ix: 0.95, // cm
    Iy: 1.16, // cm⁴
    Wy: 0.93, // cm³
    iy: 0.95, // cm
  },
  {
    id: 6,
    name: "tubo cuadrado 25x25x1.5",
    b: 0.025, // m
    h: 0.025, // m
    e: 0.0015, // m
    A: 1.35, // cm²
    pl: 1.06, // kg/m
    Ix: 1.22, // cm⁴
    Wx: 0.97, // cm³
    ix: 0.95, // cm
    Iy: 1.22, // cm⁴
    Wy: 0.97, // cm³
    iy: 0.95, // cm
  },
  {
    id: 7,
    name: "tubo cuadrado 25x25x1.8",
    b: 0.025, // m
    h: 0.025, // m
    e: 0.0018, // m
    A: 1.59, // cm²
    pl: 1.25, // kg/m
    Ix: 1.39, // cm⁴
    Wx: 1.11, // cm³
    ix: 0.94, // cm
    Iy: 1.39, // cm⁴
    Wy: 1.11, // cm³
    iy: 0.94, // cm
  },
  {
    id: 8,
    name: "tubo cuadrado 25x25x2",
    b: 0.025, // m
    h: 0.025, // m
    e: 0.0020, // m
    A: 1.74, // cm²
    pl: 1.36, // kg/m
    Ix: 1.49, // cm⁴
    Wx: 1.19, // cm³
    ix: 0.93, // cm
    Iy: 1.49, // cm⁴
    Wy: 1.19, // cm³
    iy: 0.93, // cm
  },
  {
    id: 9,
    name: "tubo cuadrado 30x30x1.4",
    b: 0.030, // m
    h: 0.030, // m
    e: 0.0014, // m
    A: 1.55, // cm²
    pl: 1.22, // kg/m
    Ix: 28, // cm⁴
    Wx: 1.39, // cm³
    ix: 1.16, // cm
    Iy: 28, // cm⁴
    Wy: 1.39, // cm³
    iy: 1.16, // cm
  },
  {
    id: 10,
    name: "tubo cuadrado 30x30x1.5",
    b: 0.030, // m
    h: 0.030, // m
    e: 0.0015, // m
    A: 1.65, // cm²
    pl: 1.30, // kg/m
    Ix: 2.20, // cm⁴
    Wx: 1.47, // cm³
    ix: 1.15, // cm
    Iy: 2.20, // cm⁴
    Wy: 1.47, // cm³
    iy: 1.15, // cm
  },
  {
    id: 11,
    name: "tubo cuadrado 30x30x1.8",
    b: 0.030, // m
    h: 0.030, // m
    e: 0.0018, // m
    A: 1.95, // cm²
    pl: 1.53, // kg/m
    Ix: 2.53, // cm⁴
    Wx: 1.68, // cm³
    ix: 1.14, // cm
    Iy: 2.53, // cm⁴
    Wy: 1.68, // cm³
    iy: 1.14, // cm
  },
  {
    id: 12,
    name: "tubo cuadrado 30x30x2",
    b: 0.030, // m
    h: 0.030, // m
    e: 0.0020, // m
    A: 2.14, // cm²
    pl: 1.68, // kg/m
    Ix: 2.73, // cm⁴
    Wx: 1.82, // cm³
    ix: 1.13, // cm
    Iy: 2.73, // cm⁴
    Wy: 1.82, // cm³
    iy: 1.13, // cm
  },
  {
    id: 13,
    name: "tubo cuadrado 40x40x1.4",
    b: 0.040, // m
    h: 0.040, // m
    e: 0.0014, // m
    A: 2.11, // cm²
    pl: 1.66, // kg/m
    Ix: 5.18, // cm⁴
    Wx: 2.59, // cm³
    ix: 1.57, // cm
    Iy: 5.18, // cm⁴
    Wy: 2.59, // cm³
    iy: 1.57, // cm
  },
  {
    id: 14,
    name: "tubo cuadrado 40x40x1.5",
    b: 0.040, // m
    h: 0.040, // m
    e: 0.0015, // m
    A: 2.25, // cm²
    pl: 1.77, // kg/m
    Ix: 5.49, // cm⁴
    Wx: 2.75, // cm³
    ix: 1.56, // cm
    Iy: 5.49, // cm⁴
    Wy: 2.75, // cm³
    iy: 1.56, // cm
  },
  {
    id: 15,
    name: "tubo cuadrado 40x40x1.8",
    b: 0.040, // m
    h: 0.040, // m
    e: 0.0018, // m
    A: 2.67, // cm²
    pl: 2.09, // kg/m
    Ix: 6.39, // cm⁴
    Wx: 3.19, // cm³
    ix: 1.55, // cm
    Iy: 6.39, // cm⁴
    Wy: 3.19, // cm³
    iy: 1.55, // cm
  },
  {
    id: 16,
    name: "tubo cuadrado 40x40x2",
    b: 0.040, // m
    h: 0.040, // m
    e: 0.0020, // m
    A: 2.94, // cm²
    pl: 2.31, // kg/m
    Ix: 6.95, // cm⁴
    Wx: 3.47, // cm³
    ix: 1.54, // cm
    Iy: 6.95, // cm⁴
    Wy: 3.47, // cm³
    iy: 1.54, // cm
  },
  {
    id: 17,
    name: "tubo cuadrado 40x40x2.5",
    b: 0.040, // m
    h: 0.040, // m
    e: 0.0025, // m
    A: 3.59, // cm²
    pl: 2.82, // kg/m
    Ix: 8.23, // cm⁴
    Wx: 4.12, // cm³
    ix: 1.51, // cm
    Iy: 8.23, // cm⁴
    Wy: 4.12, // cm³
    iy: 1.51, // cm
  },
  {
    id: 18,
    name: "tubo cuadrado 40x40x3",
    b: 0.040, // m
    h: 0.040, // m
    e: 0.0030, // m
    A: 4.21, // cm²
    pl: 3.30, // kg/m
    Ix: 9.36, // cm⁴
    Wx: 4.68, // cm³
    ix: 1.49, // cm
    Iy: 9.36, // cm⁴
    Wy: 4.68, // cm³
    iy: 1.49, // cm
  },
  {
    id: 19,
    name: "tubo cuadrado 40x40x4",
    b: 0.040, // m
    h: 0.040, // m
    e: 0.0040, // m
    A: 5.35, // cm²
    pl: 4.20, // kg/m
    Ix: 11.18, // cm⁴
    Wx: 5.59, // cm³
    ix: 1.45, // cm
    Iy: 11.18, // cm⁴
    Wy: 5.59, // cm³
    iy: 1.45, // cm
  },
  {
    id: 20,
    name: "tubo cuadrado 50x50x1.4",
    b: 0.050, // m
    h: 0.050, // m
    e: 0.0014, // m
    A: 2.67, // cm²
    pl: 2.10, // kg/m
    Ix: 10.42, // cm⁴
    Wx: 4.17, // cm³
    ix: 1.97, // cm
    Iy: 10.42, // cm⁴
    Wy: 4.17, // cm³
    iy: 1.97, // cm
  },
  {
    id: 21,
    name: "tubo cuadrado 50x50x1.5",
    b: 0.050, // m
    h: 0.050, // m
    e: 0.0015, // m
    A: 2.85, // cm²
    pl: 2.24, // kg/m
    Ix: 11.07, // cm⁴
    Wx: 4.43, // cm³
    ix: 1.97, // cm
    Iy: 11.07, // cm⁴
    Wy: 4.43, // cm³
    iy: 1.97, // cm
  },
  {
    id: 22,
    name: "tubo cuadrado 50x50x1.8",
    b: 0.050, // m
    h: 0.050, // m
    e: 0.0018, // m
    A: 3.39, // cm²
    pl: 2.66, // kg/m
    Ix: 12.95, // cm⁴
    Wx: 5.18, // cm³
    ix: 1.96, // cm
    Iy: 12.95, // cm⁴
    Wy: 5.18, // cm³
    iy: 1.96, // cm
  },
  {
    id: 23,
    name: "tubo cuadrado 50x50x2",
    b: 0.050, // m
    h: 0.050, // m
    e: 0.0020, // m
    A: 3.74, // cm²
    pl: 2.93, // kg/m
    Ix: 14.15, // cm⁴
    Wx: 5.66, // cm³
    ix: 1.95, // cm
    Iy: 14.15, // cm⁴
    Wy: 5.66, // cm³
    iy: 1.95, // cm
  },
  {
    id: 24,
    name: "tubo cuadrado 50x50x2.5",
    b: 0.050, // m
    h: 0.050, // m
    e: 0.0025, // m
    A: 4.59, // cm²
    pl: 3.60, // kg/m
    Ix: 16.96, // cm⁴
    Wx: 6.78, // cm³
    ix: 1.92, // cm
    Iy: 16.96, // cm⁴
    Wy: 6.78, // cm³
    iy: 1.92, // cm
  },
  {
    id: 25,
    name: "tubo cuadrado 50x50x3",
    b: 0.050, // m
    h: 0.050, // m
    e: 0.0030, // m
    A: 5.41, // cm²
    pl: 4.25, // kg/m
    Ix: 19.50, // cm⁴
    Wx: 7.80, // cm³
    ix: 1.90, // cm
    Iy: 19.50, // cm⁴
    Wy: 7.80, // cm³
    iy: 1.90, // cm
  },
  {
    id: 26,
    name: "tubo cuadrado 50x50x4",
    b: 0.050, // m
    h: 0.050, // m
    e: 0.0040, // m
    A: 6.95, // cm²
    pl: 5.45, // kg/m
    Ix: 23.84, // cm⁴
    Wx: 9.54, // cm³
    ix: 1.85, // cm
    Iy: 23.84, // cm⁴
    Wy: 9.54, // cm³
    iy: 1.85, // cm
  },
  {
    id: 27,
    name: "tubo cuadrado 60x60x1.5",
    b: 0.060, // m
    h: 0.060, // m
    e: 0.0015, // m
    A: 3.45, // cm²
    pl: 2.71, // kg/m
    Ix: 19.52, // cm⁴
    Wx: 6.51, // cm³
    ix: 2.38, // cm
    Iy: 19.52, // cm⁴
    Wy: 6.51, // cm³
    iy: 2.38, // cm
  },
  {
    id: 28,
    name: "tubo cuadrado 60x60x1.8",
    b: 0.060, // m
    h: 0.060, // m
    e: 0.0018, // m
    A: 4.11, // cm²
    pl: 3.22, // kg/m
    Ix: 22.95, // cm⁴
    Wx: 7.65, // cm³
    ix: 2.36, // cm
    Iy: 22.95, // cm⁴
    Wy: 7.65, // cm³
    iy: 2.36, // cm
  },
  {
    id: 29,
    name: "tubo cuadrado 60x60x2",
    b: 0.060, // m
    h: 0.060, // m
    e: 0.0020, // m
    A: 4.54, // cm²
    pl: 3.56, // kg/m
    Ix: 25.15, // cm⁴
    Wx: 8.38, // cm³
    ix: 2.35, // cm
    Iy: 25.15, // cm⁴
    Wy: 8.38, // cm³
    iy: 2.35, // cm
  },
  {
    id: 30,
    name: "tubo cuadrado 60x60x2.5",
    b: 0.060, // m
    h: 0.060, // m
    e: 0.0025, // m
    A: 5.59, // cm²
    pl: 4.39, // kg/m
    Ix: 30.36, // cm⁴
    Wx: 10.12, // cm³
    ix: 2.33, // cm
    Iy: 30.36, // cm⁴
    Wy: 10.12, // cm³
    iy: 2.33, // cm
  },
  {
    id: 31,
    name: "tubo cuadrado 60x60x3",
    b: 0.060, // m
    h: 0.060, // m
    e: 0.0030, // m
    A: 6.61, // cm²
    pl: 5.19, // kg/m
    Ix: 35.17, // cm⁴
    Wx: 11.72, // cm³
    ix: 2.31, // cm
    Iy: 35.17, // cm⁴
    Wy: 11.72, // cm³
    iy: 2.31, // cm
  },
  {
    id: 32,
    name: "tubo cuadrado 60x60x4",
    b: 0.060, // m
    h: 0.060, // m
    e: 0.0040, // m
    A: 8.55, // cm²
    pl: 6.71, // kg/m
    Ix: 43.65, // cm⁴
    Wx: 14.55, // cm³
    ix: 2.26, // cm
    Iy: 43.65, // cm⁴
    Wy: 14.55, // cm³
    iy: 2.26, // cm
  },
  {
    id: 33,
    name: "tubo cuadrado 70x70x1.5",
    b: 0.070, // m
    h: 0.070, // m
    e: 0.0015, // m
    A: 4.05, // cm²
    pl: 3.18, // kg/m
    Ix: 31.46, // cm⁴
    Wx: 8.99, // cm³
    ix: 2.79, // cm
    Iy: 31.46, // cm⁴
    Wy: 8.99, // cm³
    iy: 2.79, // cm
  },
  {
    id: 34,
    name: "tubo cuadrado 70x70x1.8",
    b: 0.070, // m
    h: 0.070, // m
    e: 0.0018, // m
    A: 4.83, // cm²
    pl: 3.79, // kg/m
    Ix: 37.09, // cm⁴
    Wx: 10.60, // cm³
    ix: 2.77, // cm
    Iy: 37.09, // cm⁴
    Wy: 10.60, // cm³
    iy: 2.77, // cm
  },
  {
    id: 35,
    name: "tubo cuadrado 70x70x2",
    b: 0.070, // m
    h: 0.070, // m
    e: 0.0020, // m
    A: 5.34, // cm²
    pl: 4.19, // kg/m
    Ix: 40.73, // cm⁴
    Wx: 11.64, // cm³
    ix: 2.76, // cm
    Iy: 40.73, // cm⁴
    Wy: 11.64, // cm³
    iy: 2.76, // cm
  },
  {
    id: 36,
    name: "tubo cuadrado 70x70x2.5",
    b: 0.070, // m
    h: 0.070, // m
    e: 0.0025, // m
    A: 6.59, // cm²
    pl: 5.17, // kg/m
    Ix: 49.43, // cm⁴
    Wx: 14.12, // cm³
    ix: 2.74, // cm
    Iy: 49.43, // cm⁴
    Wy: 14.12, // cm³
    iy: 2.74, // cm
  },
  {
    id: 37,
    name: "tubo cuadrado 70x70x3",
    b: 0.070, // m
    h: 0.070, // m
    e: 0.0030, // m
    A: 7.81, // cm²
    pl: 6.13, // kg/m
    Ix: 57.56, // cm⁴
    Wx: 16.45, // cm³
    ix: 2.72, // cm
    Iy: 57.56, // cm⁴
    Wy: 16.45, // cm³
    iy: 2.72, // cm
  },
  {
    id: 38,
    name: "tubo cuadrado 70x70x4",
    b: 0.070, // m
    h: 0.070, // m
    e: 0.0040, // m
    A: 10.15, // cm²
    pl: 7.97, // kg/m
    Ix: 72.22, // cm⁴
    Wx: 20.64, // cm³
    ix: 2.67, // cm
    Iy: 72.22, // cm⁴
    Wy: 20.64, // cm³
    iy: 2.67, // cm
  },
  {
    id: 39,
    name: "tubo cuadrado 75x75x1.5",
    b: 0.075, // m
    h: 0.075, // m
    e: 0.0015, // m
    A: 4.35, // cm²
    pl: 3.42, // kg/m
    Ix: 38.92, // cm⁴
    Wx: 10.38, // cm³
    ix: 2.99, // cm
    Iy: 38.92, // cm⁴
    Wy: 10.38, // cm³
    iy: 2.99, // cm
  },
  {
    id: 40,
    name: "tubo cuadrado 75x75x1.8",
    b: 0.075, // m
    h: 0.075, // m
    e: 0.0018, // m
    A: 5.19, // cm²
    pl: 4.07, // kg/m
    Ix: 45.95, // cm⁴
    Wx: 12.25, // cm³
    ix: 2.98, // cm
    Iy: 45.95, // cm⁴
    Wy: 12.25, // cm³
    iy: 2.98, // cm
  },
  {
    id: 41,
    name: "tubo cuadrado 75x75x2",
    b: 0.075, // m
    h: 0.075, // m
    e: 0.0020, // m
    A: 5.74, // cm²
    pl: 4.50, // kg/m
    Ix: 50.50, // cm⁴
    Wx: 13.47, // cm³
    ix: 2.97, // cm
    Iy: 50.50, // cm⁴
    Wy: 13.47, // cm³
    iy: 2.97, // cm
  },
  {
    id: 42,
    name: "tubo cuadrado 75x75x2.5",
    b: 0.075, // m
    h: 0.075, // m
    e: 0.0025, // m
    A: 7.09, // cm²
    pl: 5.56, // kg/m
    Ix: 61.40, // cm⁴
    Wx: 16.37, // cm³
    ix: 2.94, // cm
    Iy: 61.40, // cm⁴
    Wy: 16.37, // cm³
    iy: 2.94, // cm
  },
  {
    id: 43,
    name: "tubo cuadrado 75x75x3",
    b: 0.075, // m
    h: 0.075, // m
    e: 0.0030, // m
    A: 8.41, // cm²
    pl: 6.60, // kg/m
    Ix: 71.65, // cm⁴
    Wx: 19.11, // cm³
    ix: 2.92, // cm
    Iy: 71.65, // cm⁴
    Wy: 19.11, // cm³
    iy: 2.92, // cm
  },
  {
    id: 44,
    name: "tubo cuadrado 75x75x4",
    b: 0.075, // m
    h: 0.075, // m
    e: 0.0040, // m
    A: 10.95, // cm²
    pl: 8.59, // kg/m
    Ix: 90.29, // cm⁴
    Wx: 24.08, // cm³
    ix: 2.87, // cm
    Iy: 90.29, // cm⁴
    Wy: 24.08, // cm³
    iy: 2.87, // cm
  },
  {
    id: 45,
    name: "tubo cuadrado 75x75x1.5",
    b: 0.075, // m
    h: 0.075, // m
    e: 0.0015, // m
    A: 4.35, // cm²
    pl: 3.42, // kg/m
    Ix: 38.92, // cm⁴
    Wx: 10.38, // cm³
    ix: 2.99, // cm
    Iy: 38.92, // cm⁴
    Wy: 10.38, // cm³
    iy: 2.99, // cm
  },
  {
    id: 46,
    name: "tubo cuadrado 75x75x1.8",
    b: 0.075, // m
    h: 0.075, // m
    e: 0.0018, // m
    A: 5.19, // cm²
    pl: 4.07, // kg/m
    Ix: 45.95, // cm⁴
    Wx: 12.25, // cm³
    ix: 2.98, // cm
    Iy: 45.95, // cm⁴
    Wy: 12.25, // cm³
    iy: 2.98, // cm
  },
  {
    id: 47,
    name: "tubo cuadrado 75x75x2",
    b: 0.075, // m
    h: 0.075, // m
    e: 0.0020, // m
    A: 5.74, // cm²
    pl: 4.50, // kg/m
    Ix: 50.50, // cm⁴
    Wx: 13.47, // cm³
    ix: 2.97, // cm
    Iy: 50.50, // cm⁴
    Wy: 13.47, // cm³
    iy: 2.97, // cm
  },
  {
    id: 48,
    name: "tubo cuadrado 75x75x2.5",
    b: 0.075, // m
    h: 0.075, // m
    e: 0.0025, // m
    A: 7.09, // cm²
    pl: 5.56, // kg/m
    Ix: 61.40, // cm⁴
    Wx: 16.37, // cm³
    ix: 2.94, // cm
    Iy: 61.40, // cm⁴
    Wy: 16.37, // cm³
    iy: 2.94, // cm
  },
  {
    id: 49,
    name: "tubo cuadrado 75x75x3",
    b: 0.075, // m
    h: 0.075, // m
    e: 0.0030, // m
    A: 8.41, // cm²
    pl: 6.60, // kg/m
    Ix: 71.65, // cm⁴
    Wx: 19.11, // cm³
    ix: 2.92, // cm
    Iy: 71.65, // cm⁴
    Wy: 19.11, // cm³
    iy: 2.92, // cm
  },
  {
    id: 50,
    name: "tubo cuadrado 75x75x4",
    b: 0.075, // m
    h: 0.075, // m
    e: 0.0040, // m
    A: 10.95, // cm²
    pl: 8.59, // kg/m
    Ix: 90.29, // cm⁴
    Wx: 24.08, // cm³
    ix: 2.87, // cm
    Iy: 90.29, // cm⁴
    Wy: 24.08, // cm³
    iy: 2.87, // cm
  },
  {
    id: 51,
    name: "tubo cuadrado 90x90x1.8",
    b: 0.090, // m
    h: 0.090, // m
    e: 0.0018, // m
    A: 6.27, // cm²
    pl: 4.92, // kg/m
    Ix: 80.71, // cm⁴
    Wx: 17.94, // cm³
    ix: 3.59, // cm
    Iy: 80.71, // cm⁴
    Wy: 17.94, // cm³
    iy: 3.59, // cm
  },
  {
    id: 52,
    name: "tubo cuadrado 90x90x2",
    b: 0.090, // m
    h: 0.090, // m
    e: 0.0020, // m
    A: 6.94, // cm²
    pl: 5.45, // kg/m
    Ix: 88.87, // cm⁴
    Wx: 19.75, // cm³
    ix: 3.58, // cm
    Iy: 88.87, // cm⁴
    Wy: 19.75, // cm³
    iy: 3.58, // cm
  },
  {
    id: 53,
    name: "tubo cuadrado 90x90x2.5",
    b: 0.090, // m
    h: 0.090, // m
    e: 0.0025, // m
    A: 8.59, // cm²
    pl: 6.74, // kg/m
    Ix: 108.57, // cm⁴
    Wx: 24.15, // cm³
    ix: 3.56, // cm
    Iy: 108.57, // cm⁴
    Wy: 24.15, // cm³
    iy: 3.56, // cm
  },
  {
    id: 54,
    name: "tubo cuadrado 90x90x3",
    b: 0.090, // m
    h: 0.090, // m
    e: 0.0030, // m
    A: 10.21, // cm²
    pl: 8.01, // kg/m
    Ix: 127.32, // cm⁴
    Wx: 28.29, // cm³
    ix: 3.53, // cm
    Iy: 127.32, // cm⁴
    Wy: 28.29, // cm³
    iy: 3.53, // cm
  },
  {
    id: 55,
    name: "tubo cuadrado 90x90x4",
    b: 0.090, // m
    h: 0.090, // m
    e: 0.0040, // m
    A: 13.35, // cm²
    pl: 10.48, // kg/m
    Ix: 160.02, // cm⁴
    Wx: 36.01, // cm³
    ix: 3.48, // cm
    Iy: 160.02, // cm⁴
    Wy: 36.01, // cm³
    iy: 3.48, // cm
  },
  {
    id: 56,
    name: "tubo cuadrado 100x100x1.8",
    b: 0.100, // m
    h: 0.100, // m
    e: 0.0018, // m
    A: 6.99, // cm²
    pl: 5.48, // kg/m
    Ix: 111.62, // cm⁴
    Wx: 22.32, // cm³
    ix: 4.00, // cm
    Iy: 111.62, // cm⁴
    Wy: 22.32, // cm³
    iy: 4.00, // cm
  },
  {
    id: 57,
    name: "tubo cuadrado 100x100x2",
    b: 0.100, // m
    h: 0.100, // m
    e: 0.0020, // m
    A: 7.74, // cm²
    pl: 6.07, // kg/m
    Ix: 123.01, // cm⁴
    Wx: 24.60, // cm³
    ix: 3.99, // cm
    Iy: 123.01, // cm⁴
    Wy: 24.60, // cm³
    iy: 3.99, // cm
  },
  {
    id: 58,
    name: "tubo cuadrado 100x100x2.5",
    b: 0.100, // m
    h: 0.100, // m
    e: 0.0025, // m
    A: 9.59, // cm²
    pl: 7.53, // kg/m
    Ix: 150.65, // cm⁴
    Wx: 30.13, // cm³
    ix: 3.96, // cm
    Iy: 150.65, // cm⁴
    Wy: 30.13, // cm³
    iy: 3.96, // cm
  },
  {
    id: 59,
    name: "tubo cuadrado 100x100x3",
    b: 0.100, // m
    h: 0.100, // m
    e: 0.0030, // m
    A: 11.41, // cm²
    pl: 8.96, // kg/m
    Ix: 177.08, // cm⁴
    Wx: 35.42, // cm³
    ix: 3.94, // cm
    Iy: 177.08, // cm⁴
    Wy: 35.42, // cm³
    iy: 3.94, // cm
  },
  {
    id: 60,
    name: "tubo cuadrado 100x100x4",
    b: 0.100, // m
    h: 0.100, // m
    e: 0.0040, // m
    A: 14.95, // cm²
    pl: 11.73, // kg/m
    Ix: 226.46, // cm⁴
    Wx: 45.29, // cm³
    ix: 3.89, // cm
    Iy: 226.46, // cm⁴
    Wy: 45.29, // cm³
    iy: 3.89, // cm
  },
  {
    id: 61,
    name: "tubo cuadrado 100x100x5",
    b: 0.100, // m
    h: 0.100, // m
    e: 0.0050, // m
    A: 18.36, // cm²
    pl: 14.41, // kg/m
    Ix: 271.36, // cm⁴
    Wx: 54.27, // cm³
    ix: 3.84, // cm
    Iy: 271.36, // cm⁴
    Wy: 54.27, // cm³
    iy: 3.84, // cm
  },
  {
    id: 62,
    name: "tubo cuadrado 100x100x6",
    b: 0.100, // m
    h: 0.100, // m
    e: 0.0060, // m
    A: 21.63, // cm²
    pl: 16.98, // kg/m
    Ix: 312.00, // cm⁴
    Wx: 62.40, // cm³
    ix: 3.80, // cm
    Iy: 312.00, // cm⁴
    Wy: 62.40, // cm³
    iy: 3.80, // cm
  },
  {
    id: 63,
    name: "tubo cuadrado 125x125x3",
    b: 0.125, // m
    h: 0.125, // m
    e: 0.0030, // m
    A: 14.41, // cm²
    pl: 11.31, // kg/m
    Ix: 354.53, // cm⁴
    Wx: 56.73, // cm³
    ix: 4.96, // cm
    Iy: 354.53, // cm⁴
    Wy: 56.73, // cm³
    iy: 4.96, // cm
  },
  {
    id: 64,
    name: "tubo cuadrado 125x125x4",
    b: 0.125, // m
    h: 0.125, // m
    e: 0.0040, // m
    A: 18.95, // cm²
    pl: 14.87, // kg/m
    Ix: 457.33, // cm⁴
    Wx: 73.17, // cm³
    ix: 4.91, // cm
    Iy: 457.33, // cm⁴
    Wy: 73.17, // cm³
    iy: 4.91, // cm
  },
  {
    id: 65,
    name: "tubo cuadrado 125x125x5",
    b: 0.125, // m
    h: 0.125, // m
    e: 0.0050, // m
    A: 23.36, // cm²
    pl: 18.33, // kg/m
    Ix: 552.87, // cm⁴
    Wx: 88.46, // cm³
    ix: 4.87, // cm
    Iy: 552.87, // cm⁴
    Wy: 88.46, // cm³
    iy: 4.87, // cm
  },
  {
    id: 66,
    name: "tubo cuadrado 125x125x6",
    b: 0.125, // m
    h: 0.125, // m
    e: 0.0060, // m
    A: 27.63, // cm²
    pl: 21.69, // kg/m
    Ix: 641.41, // cm⁴
    Wx: 102.63, // cm³
    ix: 4.82, // cm
    Iy: 641.41, // cm⁴
    Wy: 102.63, // cm³
    iy: 4.82, // cm
  },
];

export default perfilesTuberiaEstructural;